import { render, staticRenderFns } from "./Trip.vue?vue&type=template&id=bab852ec&scoped=true"
import script from "./Trip.vue?vue&type=script&lang=js"
export * from "./Trip.vue?vue&type=script&lang=js"
import style0 from "./Trip.vue?vue&type=style&index=0&id=bab852ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab852ec",
  null
  
)

export default component.exports